// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bulletId: __t.string().primaryKey(),
  lobbyId: __t.string(),
  ownerId: __t.string(),
  posX: __t.i32(),
  posY: __t.i32(),
  velX: __t.i32(),
  velY: __t.i32(),
  age: __t.f32(),
  shooterScale: __t.f32(),
  damage: __t.f32(),
  updatedAt: __t.timestamp(),
});
